import axios from "axios";
import { Button } from "../ui/button";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import SelectField from "../ui/SelectField";
import InputField from "../ui/InputField";
import TextAreaField from "../ui/TextAreaField";

const MovimientoInternoForm = ({ equipoId, clienteId, onClose, onSaved }) => {
  const [sedes, setSedes] = useState([]);
  const [areas, setAreas] = useState([]);

  const [sedeId, setSedeId] = useState("");
  const [areaId, setAreaId] = useState("");
  const [responsableEquipo, setResponsableEquipo] = useState("");
  const [observacion, setObservacion] = useState("");
  const [loading, setLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  /* ===============================
     Cargar sedes y áreas
     =============================== */
  useEffect(() => {
    if (!clienteId) return;

    const fetchData = async () => {
      try {
        const [sedesRes, areasRes] = await Promise.all([
          axios.get(`${API}/sedes/${clienteId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${API}/areas`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setSedes(sedesRes.data || []);
        setAreas(areasRes.data || []);
      } catch {
        toast.error("Error cargando sedes o áreas");
      }
    };

    fetchData();
  }, [API, token, clienteId]);

  /* ===============================
     Submit
     =============================== */
  const submit = async () => {
    if (!sedeId || !areaId) {
      toast.warning("Debe seleccionar sede y área");
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        `${API}/movimientos/interno/${equipoId}`,
        {
          sedeId,
          areaId,
          responsableEquipo,
          observacion,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      toast.success("Movimiento interno registrado");
      onSaved();
      onClose();
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Error al registrar movimiento interno",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      {/* Sede */}
      <SelectField
        label="Sede *"
        name="sede"
        value={sedeId}
        options={sedes}
        onChange={(e) => setSedeId(e.target.value)}
        displayFn={(s) => s.name}
      />

      {/* Área */}
      <SelectField
        label="Área *"
        name="area"
        value={areaId}
        options={areas}
        onChange={(e) => setAreaId(e.target.value)}
        displayFn={(a) => a.name}
      />

      {/* Responsable */}
      <InputField
        label="Responsable del equipo (opcional)"
        value={responsableEquipo}
        onChange={(e) => setResponsableEquipo(e.target.value)}
        placeholder="Nombre del responsable"
      />

      {/* Observación */}
      <TextAreaField
        label="Observación"
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
        rows={3}
      />

      {/* Acciones */}
      <div className="flex justify-end gap-3 pt-2">
        <Button variant="outline" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={submit} disabled={loading}>
          {loading ? "Registrando..." : "Registrar movimiento"}
        </Button>
      </div>
    </div>
  );
};

export default MovimientoInternoForm;
